import React from "react";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { getFormattedDate } from "../../../functions/time";

const Table = ({ bookmarks, handleDeleteBookmark }) => {
  return (
    <div className="table-save-popup">
      {bookmarks.length === 0 ? (
        <p className="messages">
          Oops! It looks like there aren't any bookmarks in this folder. Try
          adding some!
        </p>
      ) : (
        <>
          <div className="header">
            <div className="col">
              <p>Source</p>
            </div>
            <div className="col">
              <p>Title</p>
            </div>
            <div className="col">
              <p>Published</p>
            </div>
            <div className="col">
              <p>Added</p>
            </div>
          </div>
          <div className="rows">
            {bookmarks.map((bookmark, i) => (
              <div key={i} className="row">
                <div className="col">
                  {bookmark.sourceName_chr ? bookmark.sourceName_chr : "NA"}
                </div>
                <div className="col">{bookmark.title_chr}</div>
                <div className="col">
                  {getFormattedDate(bookmark.createdDateTime_dtm)}
                </div>
                <div className="col">
                  {getFormattedDate(bookmark.lastUpdatedDateTime_dtm)}
                </div>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default Table;
